/*
  Oneindig scrollen op collectiepagina's (vervangt de app Scroll Bee).
  - Laadt de volgende pagina zodra de bezoeker het einde van het raster nadert en plakt de producten eronder.
  - De gewone paginering (1, 2, 3) blijft in de HTML staan voor Google en voor bezoekers zonder JavaScript;
    ze wordt alleen verborgen zolang dit script actief is.
  - LET OP: in dit thema staat het blok met de paginering IN het raster (laatste kind van #main-collection-product-grid).
    Daarom: alleen productkaarten overnemen (nooit het pagineringsblok) en nieuwe kaarten VOOR dat blok invoegen.
  - Het laadpunt telt ook als de bezoeker er al voorbij is (sprong naar de onderkant, lange SEO-tekst onder het raster):
    de bovenmarge van de IntersectionObserver is daarom heel groot.
  - Wie direct op ?page=2 of later binnenkomt, krijgt boven het raster een link "Eerdere producten bekijken"
    (naar pagina 1, filters blijven behouden) en naar beneden laadt het gewoon door.
  - Na filteren/sorteren (het thema vervangt dan het raster) start het script opnieuw.
  - Gaat er iets mis bij het laden, dan komt de gewone paginering terug.
  - Zolang de app-insluiting van Scroll Bee nog aan staat, doet dit script niets (anders laden producten dubbel).
    Testen terwijl Scroll Bee nog aan staat kan met ?infinite=force in de URL.
*/
(function () {
  if (window.__fbInfiniteScroll) return;
  window.__fbInfiniteScroll = true;

  var WRAP = '#CollectionProductGrid';
  var GRID = '#main-collection-product-grid';
  var state = { grid: null, nav: null, url: null, loading: false, observer: null, sentinel: null, backLink: null };

  function scrollBeeActive() {
    if (new URLSearchParams(window.location.search).get('infinite') === 'force') return false;
    return !!document.getElementById('__scrollBeeConfig');
  }

  function nextUrl(root) {
    var a = root.querySelector(WRAP + ' ul.pagination li.next a');
    return a ? a.getAttribute('href') : null;
  }

  function isFirstPage() {
    var page = new URLSearchParams(window.location.search).get('page');
    return !page || page === '1';
  }

  function firstPageUrl() {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('infinite');
    return u.pathname + (u.search || '');
  }

  // het element dat verborgen moet worden: het rasterkind waar de paginering in zit, anders de <nav> zelf
  function paginationBlock(grid, list) {
    var node = list;
    while (node && node.parentNode && node.parentNode !== grid) node = node.parentNode;
    if (node && node.parentNode === grid) return node;
    return list.closest('nav') || list;
  }

  function isPaginationNode(node) {
    return node.matches('ul.pagination') || !!node.querySelector('ul.pagination');
  }

  // stopt het bijladen; de link naar eerdere producten blijft staan
  function cleanup(showNav) {
    if (state.observer) state.observer.disconnect();
    if (state.sentinel && state.sentinel.parentNode) state.sentinel.parentNode.removeChild(state.sentinel);
    if (showNav && state.nav) state.nav.style.display = '';
    state.observer = null;
    state.sentinel = null;
    state.url = null;
    state.loading = false;
  }

  function removeBackLink() {
    if (state.backLink && state.backLink.parentNode) state.backLink.parentNode.removeChild(state.backLink);
    state.backLink = null;
  }

  function addBackLink(grid) {
    var wrap = document.createElement('div');
    wrap.setAttribute('data-infinite-scroll-back', '');
    wrap.style.cssText = 'text-align:center;padding:0 0 24px';
    var a = document.createElement('a');
    a.href = firstPageUrl();
    a.className = 'button button--outline button--regular';
    a.textContent = '← Eerdere producten bekijken';
    wrap.appendChild(a);
    grid.insertAdjacentElement('beforebegin', wrap);
    state.backLink = wrap;
  }

  function removeDuplicates(grid) {
    var seen = {};
    Array.prototype.slice.call(grid.children).forEach(function (node) {
      if (!node.id) return;
      if (seen[node.id]) node.parentNode.removeChild(node);
      else seen[node.id] = true;
    });
  }

  function setup() {
    cleanup(false);
    removeBackLink();
    var wrap = document.querySelector(WRAP);
    var grid = document.querySelector(GRID);
    if (!wrap || !grid || !('IntersectionObserver' in window) || scrollBeeActive()) return;
    var list = wrap.querySelector('ul.pagination');
    if (!list) return;
    var url = nextUrl(document);
    var first = isFirstPage();
    if (first && !url) return;

    state.grid = grid;
    state.nav = paginationBlock(grid, list);
    state.nav.style.display = 'none';
    if (!first) addBackLink(grid);
    if (!url) return; // laatste pagina: niets meer bij te laden

    state.url = url;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('data-infinite-scroll-status', '');
    sentinel.setAttribute('role', 'status');
    sentinel.setAttribute('aria-live', 'polite');
    sentinel.style.cssText = 'min-height:1px;padding:24px 0;text-align:center;opacity:.7;clear:both;width:100%';
    grid.insertAdjacentElement('afterend', sentinel);
    state.sentinel = sentinel;

    // grote bovenmarge: het laadpunt telt ook mee als de bezoeker er al (ver) voorbij gescrold is
    state.observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
    }, { rootMargin: '1000000px 0px 800px 0px' });
    state.observer.observe(sentinel);
  }

  function loadNext() {
    if (state.loading || !state.url) return;
    state.loading = true;
    var grid = state.grid;
    var sentinel = state.sentinel;
    sentinel.textContent = 'Meer producten laden…';

    fetch(state.url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        if (grid !== state.grid) return; // raster is intussen vervangen door filteren
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID);
        if (!newGrid) throw new Error('raster niet gevonden');

        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(newGrid.children, function (node) {
          if (isPaginationNode(node)) return; // het pagineringsblok nooit overnemen
          if (node.id && document.getElementById(node.id)) return; // geen dubbele producten
          var copy = document.importNode(node, true);
          copy.querySelectorAll('img').forEach(function (img) {
            img.removeAttribute('fetchpriority');
            img.setAttribute('loading', 'lazy');
          });
          frag.appendChild(copy);
        });
        // nieuwe kaarten voor het (verborgen) pagineringsblok zetten als dat in het raster staat
        if (state.nav && state.nav.parentNode === grid) grid.insertBefore(frag, state.nav);
        else grid.appendChild(frag);
        removeDuplicates(grid);

        state.url = nextUrl(doc);
        state.loading = false;
        sentinel.textContent = '';
        document.dispatchEvent(new CustomEvent('infinite-scroll:loaded'));

        if (!state.url) {
          cleanup(false);
        } else if (state.observer) {
          // opnieuw observeren, zodat er direct wordt doorgeladen als het laadpunt nog in (of boven) beeld is
          state.observer.unobserve(sentinel);
          state.observer.observe(sentinel);
        }
      })
      .catch(function () {
        cleanup(true);
      });
  }

  function watchForRerender() {
    var wrap = document.querySelector(WRAP);
    if (!wrap || !('MutationObserver' in window)) return;
    var target = wrap.parentNode || wrap;
    new MutationObserver(function () {
      var grid = document.querySelector(GRID);
      if (grid && grid !== state.grid) setup();
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    setup();
    watchForRerender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
